/* Copyright (c) 2017 Backpack Health LLC */

import PropTypes from 'prop-types';

import COLORS from '../constants/colors';

export { COLORS };

export enum colorNamesEnum {
  'error' = 'error',
  'profile' = 'profile',
  'transparent' = 'transparent',
  'destructive' = 'destructive',
  'gsMedLight' = 'gsMedLight',
  'gsLightest' = 'gsLightest',
  'gsDarkest' = 'gsDarkest',
  'gsMiddle' = 'gsMiddle',
};

export enum typographyEnum {
  'title1' = 'title-1',
  'title2' = 'title-2',
  'title3' = 'title-3',
  'headline' = 'headline',
  'body' = 'body',
  'subhead' = 'subhead',
  'footnote' = 'footnote',
  'caption1' = 'caption-1',
}

const colorNameList = [
  'error',
  'profile',
  'white',
  'black',
  'gsMedLight',
  'middle-gray',
  'med-dark-gray',
  'lightest',
  'transparent',
  'destructive',
];

export const colorClassNames = {
  nameProp: PropTypes.oneOf(colorNameList),

  font(colorName) {
    return `font-color-${colorName}`;
  },

  fill(colorName) {
    return `fill-color-${colorName}`;
  },

  stroke(colorName) {
    return `stroke-color-${colorName}`;
  },
};

export const typography = {
  nameProp: PropTypes.oneOf(['title-1', 'title-2', 'title-3', 'headline', 'body', 'subhead', 'footnote', 'caption-1']),

  font(name) {
    return `font-${name}`;
  },
};

// export default COLORS;
